/** Shared pill chrome for /audience, /events, /emails, /integrations, and /templates. */
export const ROUNDED_SEARCH_BAR_CLASSNAME =
  'relative flex w-full items-center gap-2 rounded-lg border border-border p-1'

export const ROUNDED_SEARCH_INPUT_CLASSNAME =
  'w-full rounded-lg border-none bg-background shadow-none outline-none focus-visible:ring-0 focus-visible:ring-offset-0'

/** Sibling select triggers next to `RoundedSearchBar` — same height and radius. */
export const ROUNDED_TOOLBAR_CONTROL_CLASSNAME =
  'h-11 rounded-lg border-border font-normal shadow-none data-[size=default]:h-11 data-[size=sm]:h-11'
